if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-drawer');
        this.minicart = document.querySelector('.sn_cart_drawer')
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonBar = document.querySelector('.sn_intro_product__bar [type="submit"]');

        this.submitButtons = [
          this.submitButton,
          this.submitButtonBar,
        ].filter(f => !!f);

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      toSubmitButtons(callback) {
        this.submitButtons.forEach(el => callback(el))
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.toSubmitButtons((el) => {
          el.setAttribute('aria-disabled', true);
          el.classList.add('__loading');
        })

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.toSubmitButtons((el) => {
                el.setAttribute('aria-disabled', true);
                el.querySelector('span').classList.add('hidden');
              })
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (this.minicart) {
              this.minicart.dispatchEvent(new CustomEvent('open', {
                detail: {
                  triggerElement: this.submitButton
                }
              }))
            }

            if (!this.error)
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response,
            });

            this.error = false;
            this.cart.renderContents(response);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.toSubmitButtons((el) => {
              el.classList.remove('__loading');
              el.removeAttribute('aria-disabled');
            })
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.sn_intro_product__error');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.sn_intro_product__error__message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.toSubmitButtons((el) => {
            el.setAttribute('disabled', 'disabled');
            if (text) el.querySelector('span').textContent = text;
          })
        } else {
          this.toSubmitButtons((el) => {
            el.removeAttribute('disabled');
            el.querySelector('span').textContent = window.variantStrings.addToCart;
          })
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
